import React from 'react';
import { Check } from 'lucide-react';

export const FormActions = ({ 
  steps, 
  currentStep, 
  setCurrentStep, 
  isSubmitting, 
  submitStatus,
  submitText,
  resetText,
  showReset,
  onReset,
  theme 
}) => {
  return (
    <div className="flex gap-2 mt-6">
      {steps.length > 1 && currentStep > 0 && (
        <button
          type="button"
          onClick={() => setCurrentStep(currentStep - 1)}
          className={theme.secondaryButton}
        >
          Previous
        </button>
      )}
      
      {steps.length > 1 && currentStep < steps.length - 1 ? (
        <button
          type="button"
          onClick={() => setCurrentStep(currentStep + 1)}
          className={theme.button}
        >
          Next
        </button>
      ) : (
        <>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`${theme.button} flex items-center space-x-2`}
          >
            {isSubmitting ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" />
                <span>Submitting...</span>
              </>
            ) : (
              <>
                {submitStatus === 'success' && <Check size={16} />}
                <span>{submitText}</span>
              </>
            )}
          </button>
          
          {showReset && (
            <button
              type="button"
              onClick={onReset}
              className={theme.secondaryButton}
            >
              {resetText}
            </button>
          )}
        </>
      )}
    </div>
  );
};
